import { ActivityIdService } from '@supply-mover-2-0/core';
import { ModuleRegistry } from '../services/ModuleRegistry';

/**
 * Register a description resolver synchronously at module-load time so
 * the ActivityIdService's lazy rotation has access to the route map
 * BEFORE the first API call fires. This sidesteps the React effect
 * ordering issue where child components' useEffects (which fire API
 * calls) run before parent-level route-sync useEffects.
 *
 * The service then rotates lazily based on `window.location.pathname` —
 * every call to ApiService picks up the freshly resolved description for
 * whatever path the browser is currently on, regardless of whether any
 * React effect has run yet.
 */
ActivityIdService.getInstance().setDescriptionResolver((pathname) =>
	ModuleRegistry.getActivityDescriptionForPath(pathname),
);

/**
 * Renders nothing. Kept for backwards compatibility with existing app
 * mount sites — the lazy-rotation path on the service handles all
 * navigation transitions automatically, so this component is now a
 * no-op. Safe to remove from App.tsx mount points whenever convenient.
 */
export function ActivityIdRouteSync(): null {
	return null;
}
